/*
 * @Author: Fan
 * @Date: 2020-04-26 12:12:53
 * @description:
 * @LastEditors: Fan
 */
import { ControlAttributeType, } from "@cloudpivot/form/typings";
import baseAttribute from "@cloudpivot/form/src/common/component-base-attribute";
export default {
    groups: {
        base: {
            label: "基础信息",
            keys: ["name", "visible", "style", "tips", "dataItemName"],
        },
        controller: {
            label: "控制属性",
            keys: ["count", "allowClear"],
        },
    },
    properties: {
        name: Object.assign({}, baseAttribute.name),
        style: Object.assign({}, baseAttribute.style),
        dataItemName: Object.assign({}, baseAttribute.dataItemName),
        count: {
            inputMethod: ControlAttributeType.Dropdown,
            options: {
                list: () => {
                    let s = [];
                    let i = 1;
                    while (i <= 10) {
                        s.push({ label: i, value: i });
                        i++;
                    }
                    return s;
                },
            },
        },
    },
};
